import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { KeyPhraseCategory } from './api/key-phrase-category';

export const onClickAutoDefinitionHighlights = ({
	contentId,
	sessionId,
	keyPhraseCategory,
	fieldType,
}: {
	contentId: string;
	sessionId: string;
	keyPhraseCategory: KeyPhraseCategory | undefined;
	fieldType?: string;
}): AnalyticsEventPayload => ({
	action: 'clicked',
	actionSubject: 'aiDefinitionsAutohighlights',
	source: 'viewPageScreen',
	eventType: 'ui',
	attributes: {
		contentId,
		readingAidsSessionId: sessionId,
		keyPhraseCategory: keyPhraseCategory || KeyPhraseCategory.AUTO,
		fieldType,
	},
});
